import './GoBackBtn.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const GoBackBtn = _ref => {
  let {
    label,
    handleClick,
    isFormStepBack = false
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn btn-tertiary ${isFormStepBack ? 'form-step-back' : ''}`,
    type: "button",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("svg", {
    className: "go-back-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.179",
    height: "9",
    viewBox: "0 0 5.179 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbols",
    transform: "translate(6 9.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron-right",
    "data-name": "ic/chevron-right",
    transform: "translate(-7 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron-right-2",
    "data-name": "ic_chevron-right",
    d: "M14.5,8.394h0L10,13,5.5,8.394a1.9,1.9,0,0,1,2.692-.031l.031.031L10,10.212h0l1.776-1.818a1.9,1.9,0,0,1,2.692-.031Z",
    transform: "translate(0 20) rotate(-90)",
    fill: "currentColor"
  })))), label));
};
const mainStyles = "mzv9fak";
const mainRtlStyles = "m1ky34yc";
const mainLtrStyles = "mboka74";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `  ${mainStyles}  ${rtl ? mainRtlStyles : mainLtrStyles} `
  }, children);
};
export default GoBackBtn;